import React from 'react';

export default function LikeIcon() {
  return (
    <svg
      className="icon icon-like"
      xmlns="http://www.w3.org/2000/svg"
      width="14.53"
      height="10"
      viewBox="0 0 14.53 10"
    >
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M1227.24 304.88v-9.76h14.52v9.76h-9.68a.62.62 0 0 0 .19-.13l7.71-7.71a.6.6 0 0 0 0-.86.6.6 0 0 0-.86 0l-7.28 7.28-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23c.06.06.12.1.2.13zm4.84 0h-.48a.6.6 0 0 0 .48 0z"
          />
        </clipPath>
      </defs>
      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit="50"
        strokeWidth="2"
        d="M1239.98 296.18a.6.6 0 0 0-.86 0l-7.28 7.28-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z"
        clipPath="url(&quot;#a&quot;)"
        transform="translate(-1227.24 -295)"
      />
      <path
        fill="#4a4a4a"
        d="M12.74 1.18a.6.6 0 0 0-.86 0L4.6 8.46l-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z"
      />
    </svg>
  );
}
